import { atom } from "jotai";

import type { MergeField } from "../hooks/useReportQuery";

// Findings rendered in the report panel, in display order — flat list across
// backend report-section order so commands can iterate "next/previous finding" without
// re-traversing the section tree. Written by CaseViewer when useReport data
// resolves, read by advanceFocusedFinding.
export const orderedFindingsAtom = atom<MergeField[]>([]);

// Index of the currently-focused finding in `orderedFindingsAtom`. Null when
// no finding is focused — Tab in that state falls back to viewport cycling.
// Set when the user clicks a finding (CaseViewer.handleFindingSelectSimplified);
// cleared by Escape and by clicking a viewport.
export const focusedFindingIndexAtom = atom<number | null>(null);
